<script setup>
import { ref } from 'vue';

// Owns its own modal rather than asking the sidebar to open one: teammate
// editors are full-screen and render without the sidebar. The modal teleports
// to <body>, so it is not clipped by the chat bubble it is opened from.
const showAiUsage = ref(false);
</script>

<template>
    <div>
        <button-primary size="sm" @click="showAiUsage = true">
            {{ _mft('dashboard:aiSpend.getMoreUsage') }}
        </button-primary>

        <utility-ai-usage v-if="showAiUsage" start-in-purchase @close="showAiUsage = false" />
    </div>
</template>
